const article = {
    slug: "first_raf_simons_experience",
    category: "BRAND ENTRY",
    title: "初めてのRAF SIMONSをレンタル体験",
    listDescription:
      "ユースカルチャー、音楽、グラフィック、オーバーサイズ。RAF SIMONSを“着ること”から理解する入口ページ。",
    seo: {
      title:
        "初めてのRAF SIMONSをレンタル体験｜ラフシモンズのアーカイブを着て知るEnclopedia",
      description:
        "RAF SIMONSが気になるけれど、どんなブランドか分からない方へ。ラフシモンズの魅力、ユースカルチャー、音楽、グラフィック、オーバーサイズ、Riot Riot RiotやCloserなどのアーカイブ文脈を分かりやすく解説し、EnclopediaでレンタルできるRAF SIMONSへ案内します。",
      keyword:
        "初めてのRAF SIMONS,RAF SIMONS 初めて,ラフシモンズ 初めて,RAF SIMONS とは,ラフシモンズ どんなブランド,RAF SIMONS レンタル,ラフシモンズ レンタル,RAF SIMONS アーカイブ,ラフシモンズ アーカイブ,RAF SIMONS 名作,ラフシモンズ 名作,Riot Riot Riot,Virginia Creeper,Consumed,Closer,ラフシモンズ オーバーサイズ,ラフシモンズ ボンバージャケット,enclopedia,アンクロペディア",
      canonicalPath: "/archive_guide/first_raf_simons_experience",
    },
    hero: {
      label: "FIRST RAF SIMONS EXPERIENCE",
      number: "07 / ENTRY",
      titleLines: ["初めての", "RAF SIMONSをレンタル体験。"],
      body:
        "RAF SIMONSは、\n服だけで完結するブランドではありません。\n音楽、アート、グラフィック、ユースカルチャー、そして若者の不安や反抗心までを服に落とし込んできたブランドです。\n初めて知るなら、まずは“着ることで分かる空気感”から入るのが自然です。",
      keywords: [
        "first experience",
        "youth culture",
        "archive",
        "raf simons",
      ],
      visualLabel: "ARCHIVE EXPERIENCE",
      visualTitle: ["服を着るというより、", "時代の空気をまとう。"],
      image: "media/archive_fashion/archive_guide7.png",
      imageAlt:
        "初めてのRAF SIMONSをレンタル体験するためのアーカイブガイド画像",
      ctaLabel: "レンタルできるRAF SIMONSを見る",
      ctaHref:
        "https://www.enclopedia-official.com/brand/RAF%20SIMONS%EF%BC%88%E3%83%A9%E3%83%95%E3%82%B7%E3%83%A2%E3%83%B3%E3%82%BA%EF%BC%89/?number=61",
    },
    thesis: {
      text:
        "RAF SIMONSは、若者の文化や感情を、テーラリングやグラフィック、シルエットによって服へ変換したブランドです。",
      keywords: ["youth", "music", "archive"],
    },
    sections: {
      whyThisPage: {
        label: "02 / WHY THIS PAGE?",
        titleLines: [
          "RAF SIMONSが気になる。",
          "でも、なぜアーカイブで評価されるのか分からない。",
        ],
        body:
          "RAF SIMONSは、古着市場やアーカイブシーンで強く評価されるブランドです。\nしかし初めて見る人にとっては、“高額なアーカイブ”“有名人が着ているブランド”“グラフィックが強い服”という印象に留まりやすい。\nこのページでは、ラフシモンズを単なるプレミア服ではなく、ユースカルチャー、音楽、アート、時代の空気を服にしたブランドとして整理します。",
      },
  
      brandOverview: {
        label: "03 / BRAND OVERVIEW",
        titleLines: [
          "若者の空気を、",
          "メンズウェアの形へ変えたブランド。",
        ],
        body:
          "RAF SIMONSは、ベルギー出身のデザイナー、ラフ・シモンズによるブランドです。\n1995年に本人名義ブランドを開始し、ユースカルチャー、音楽、アート、サブカルチャーを鋭いメンズウェアへ落とし込んできました。\n彼の服は、単に奇抜なデザインではなく、若者の孤独、反抗、集団性、憧れといった感情を、シルエットやグラフィック、素材感として表現してきた点に特徴があります。",
        knowledgeItems: [
          {
            title: "ユースカルチャーは、装飾ではなく主題。",
            text:
              "RAF SIMONSにおける若者文化は、単なる引用ではありません。音楽、学校、クラブ、反抗、孤独といった感覚が服の形やグラフィックに変換されています。",
          },
          {
            title: "オーバーサイズは、流行ではなく感情の輪郭。",
            text:
              "大きなニット、長い袖、余白のあるアウターは、身体を大きく見せるだけではありません。若者特有の不安定さや防御感を含んだシルエットとして読めます。",
          },
          {
            title: "グラフィックは、服の表面ではなくメッセージ。",
            text:
              "バンド、アート、写真、タイポグラフィ。RAF SIMONSのグラフィックは装飾ではなく、そのシーズンの思想やムードを強く伝える要素です。",
          },
          {
            title: "アーカイブで評価される理由。",
            text:
              "2000年代初期を中心とした作品は、単なる古着ではなく、当時のカルチャーとファッションの接点を示す資料として評価されています。",
          },
        ],
      },
  
      lineGuide: {
        label: "04 / HOW TO SEE RAF SIMONS?",
        titleLines: [
          "RAF SIMONSを見るなら、",
          "まず4つの視点から。",
        ],
        items: [
          {
            tag: "ENTRY 01",
            title: "YOUTH CULTURE",
            text:
              "若者の集団性、不安、反抗、孤独をどう服にしているか。RAF SIMONSを理解する最も重要な視点です。",
          },
          {
            tag: "ENTRY 02",
            title: "MUSIC & GRAPHIC",
            text:
              "Joy Divisionやニューウェーブ、パンク的なムードなど、音楽やグラフィックが服のメッセージとして機能します。",
          },
          {
            tag: "ENTRY 03",
            title: "OVERSIZED SILHOUETTE",
            text:
              "大きなニット、ボンバージャケット、細いパンツなど、身体との距離感がRAF SIMONSらしさを作ります。",
          },
          {
            tag: "ENTRY 04",
            title: "ARCHIVE SEASONS",
            text:
              "Riot Riot Riot、Virginia Creeper、Consumed、Closerなど、シーズン名ごとに語られる強い文脈があります。",
          },
        ],
      },
  
      firstExperience: {
        label: "05 / FIRST EXPERIENCE",
        titleLines: ["初めて着ると、", "何が分かるのか。"],
        intro:
          "RAF SIMONSは、写真で見るよりも、実際に着たときのサイズ感、重さ、グラフィックの距離で理解が深まるブランドです。",
        items: [
          {
            index: "01",
            title: "服というより、ムードを着る感覚がある",
            text:
              "ラフシモンズの服は、形だけでなく空気感が強い。音楽、青春、反抗、静けさが、シルエットやプリントから立ち上がります。",
          },
          {
            index: "02",
            title: "オーバーサイズの意味が分かる",
            text:
              "単に大きい服ではなく、身体を包む余白や袖の長さが、独特の孤独感や緊張感を作ります。着るとその距離感が見えてきます。",
          },
          {
            index: "03",
            title: "アーカイブの価格ではなく、残る理由が分かる",
            text:
              "なぜ古いRAF SIMONSが評価され続けるのか。着ることで、グラフィックやシーズン背景が単なるプレミアではないことが分かります。",
          },
        ],
      },
  
      quote: {
        textLines: [
          "若者の不安も、",
          "服のシルエットになる。",
        ],
      },
  
      whyRent: {
        label: "06 / WHY RENT?",
        titleLines: [
          "初めてのRAF SIMONSほど、",
          "レンタルで理解が深まる。",
        ],
        items: [
          {
            number: "01",
            title: "サイズ感を実際に確かめられる",
            text:
              "RAF SIMONSはシーズンによってシルエットの癖が強く、写真や寸法だけでは印象が読み切れない場合があります。",
          },
          {
            number: "02",
            title: "グラフィックの強さを体験できる",
            text:
              "プリントやメッセージ性のある服は、見るのと着るのでは印象が変わります。自分の生活に入るかを確かめられます。",
          },
          {
            number: "03",
            title: "高額アーカイブを所有前に理解できる",
            text:
              "RAF SIMONSのアーカイブは高額化しているものも多いため、まず体験として理解できることには大きな意味があります。",
          },
        ],
      },
  
      inventory: {
        label: "07 / AVAILABLE ARCHIVE",
        titleLines: ["Enclopediaで", "体験できるRAF SIMONS。"],
        body:
          "実在庫への導線は、“RAF SIMONSを知る続き”として設計します。まず背景を理解し、次に実物で確かめる流れを作ります。",
        items: [
          {
            meta: "RAF SIMONS / 2022SS",
            title: "テーラードブレザー",
            text:
              "端正なジャケットの形を残しながら、RAF SIMONSらしい緊張感とサイズバランスを体験できる一着。",
            href:
              "https://www.enclopedia-official.com/product/5d8729e6-36f6-429c-982b-6f3f4474b68a",
            image:
              "media/product/1776673803.38983445d8729e6-36f6-429c-982b-6f3f4474b68a.png"
          },
          {
            meta: "RAF SIMONS / 2022-2023AW",
            title: "ボンバージャケット",
            text:
              "西洋絵画的なイメージや重さのあるムードを、現代的なアウターとして着ることができるアーカイブ。",
            href:
              "https://www.enclopedia-official.com/product/c1306d6c-6029-4aaa-a316-9d8047c79695",
            image:
              "media/product/1771860586.6694794c1306d6c-6029-4aaa-a316-9d8047c79695.jpg"
          },
        ],
      },
  
      faq: {
        label: "08 / FAQ",
        titleLines: ["初めての人が、", "気になりやすいこと。"],
        items: [
          {
            question: "RAF SIMONSは、どんなブランドですか？",
            answer:
              "ベルギーのデザイナー、ラフ・シモンズによるブランドです。ユースカルチャー、音楽、アートを背景に、メンズウェアの見え方を大きく変えてきました。",
          },
          {
            question: "RAF SIMONSのアーカイブはなぜ評価されていますか？",
            answer:
              "特定の時代のユースカルチャーや音楽、グラフィック、シルエットが強く反映されているため、単なる古着ではなく文化的な資料としても評価されています。",
          },
          {
            question: "初めてなら、どのアイテムから見るのがおすすめですか？",
            answer:
              "ジャケット、ボンバージャケット、シャツ、ニットなど、日常的な形を持ちながらサイズ感やグラフィックに特徴があるアイテムがおすすめです。",
          },
          {
            question: "RAF SIMONSはレンタルで試す意味がありますか？",
            answer:
              "あります。サイズ感、グラフィックの強さ、アーカイブ特有のムードは、写真より実際に着ることで理解しやすくなります。",
          },
          {
            question: "レンタル後に購入もできますか？",
            answer:
              "対象アイテムは、レンタル体験を経たうえで購入相談へ進める導線を想定しています。",
          },
        ],
      },
  
      finalCta: {
        titleLines: [
          "初めてのRAF SIMONSを、",
          "レンタルから始める。",
        ],
        body:
          "ユースカルチャー、音楽、グラフィック、オーバーサイズ。\nEnclopediaで、RAF SIMONSのアーカイブを体験してください。",
        buttonLabel: "レンタルできるRAF SIMONSを見る",
        buttonHref:
          "https://www.enclopedia-official.com/brand/RAF%20SIMONS%EF%BC%88%E3%83%A9%E3%83%95%E3%82%B7%E3%83%A2%E3%83%B3%E3%82%BA%EF%BC%89/?number=61",
      },
    },
  };

export default article;
